import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router';

import * as Sentry from '@sentry/react';

import { isProductionEnvironment } from 'Utils/environments';

type SentrySettings = {
  dsn?: string;
  sentryEnvironment?: string;
};

type SentryInitializationOptions = {
  sentrySettings: SentrySettings;
};

export const initializeSentry = ({ sentrySettings }: SentryInitializationOptions): void => {
  if (!isProductionEnvironment()) {
    console.log('Sentry disabled in development environment');
    return;
  }

  if (!sentrySettings?.dsn || !sentrySettings?.sentryEnvironment) {
    console.log('Sentry configuration missing, skipping initialization');
    return;
  }

  try {
    Sentry.init({
      dsn: sentrySettings.dsn,
      environment: sentrySettings.sentryEnvironment,
      integrations: [
        Sentry.reactRouterV7BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        }),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true
        }),
        Sentry.captureConsoleIntegration(),
        Sentry.httpClientIntegration(),
        Sentry.extraErrorDataIntegration()
      ],
      tracesSampleRate: 1.0
    });

    console.log('Sentry initialized successfully');
  } catch (error) {
    console.error('Failed to initialize Sentry:', error);
  }
};
